module.exports = __webpack_public_path__ + "img/2009-1.05b3ef45.jpg";